export default __webpack_public_path__ + "static/media/Jehangir-Mahal.0b0a155e.jpg";